import { render, staticRenderFns } from "./ProgressDetails.vue?vue&type=template&id=8f83e30c&scoped=true"
import script from "./ProgressDetails.vue?vue&type=script&lang=ts"
export * from "./ProgressDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProgressDetails.vue?vue&type=style&index=0&id=8f83e30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f83e30c",
  null
  
)

export default component.exports